export const API_BASE = process.env.REACT_APP_SERVER;
export const SHOW_ASISTENCIA_MENU = process.env.REACT_APP_SHOW_ASISTENCIA_MENU === 'true';
